module.exports = require("@vscode-alt/monaco-editor/esm/vs/base/browser/keyboardEvent");